<style scoped lang='stylus'>
@import '../../../assets/style/vars.styl'
.running-count-record
  display flex
  // align-items  center
  width 702px
  padding 32px 24px 32px 32px;
  // border-bottom 1px solid #efefef
  box-sizing border-box
  background-color #fff
  margin 16px auto
  border-radius 8px
  // overflow hidden
  &:active
    opacity .8
  .record-left
    flex 1
    display flex
    flex-shrink 0
    flex-direction column
    padding-right 20px
    box-sizing border-box
    overflow hidden
    .record-name
      max-width 300px
      font-size 28px
      color #2a2a30
      font-weight 500
      line-height 40px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      margin-bottom 12px
    .record-type
      font-size 24px
      color #828393
      line-height 34px
      margin-bottom 8px
    .record-time
      font-size 24px
      line-height 34px
      color #828393
  .record-right
    position relative
    flex-shrink 0
    // margin-left 120px
    display flex
    flex-direction column
    text-align right
    align-items flex-end 
    .record-amount
      font-base3(34px, 48px, #828393)
      flex 1
      font-weight bold
      &.dark
        color #FF5572
    .link-arrow
      width 12px
      height 19px
      // display inline-block
      // width 16px
      // height 16px
      // margin-left 16px
      // border 1px solid #999
      // border-left none
      // border-top none
      // transform rotate(-45deg)

      &.hide
        border-right none
        border-bottom none
</style>

<template>
  <div class="running-count-record" @click="recordHandler">
    <div class="record-left">
      <span class="record-name">{{item.title || '--'}}</span>
      <span class="record-type">{{item.flowType | typeString}}</span>
      <span class="record-time">{{item.dateTime}}</span>
    </div>
    <div class="record-right">
      <!-- 2: 提现 -->
      <span class="record-amount" :class="[item.flowType !== 2 ? 'dark' : '']">{{item.flowType | preIcon}}{{item.amount | formatPrice}}</span>
      <!-- <span class="link-arrow" :class="[WalletRunningCountTypeMapper[item.flowType].wxDetailLink ? '' : 'hide']"></span> -->
      <img v-if="item.flowType !== 2" class="link-arrow" src="https://oss.turingsenseai.com/1611130490901791621.png">
    </div>
  </div>
</template>
<script>
import { WalletRunningCountTypeMapper } from '../../../common/constant'
import arrowImg from './../../../../src/assets/images/wallet/arrow-right.png';

export default {
  name: 'running-count-record',

  props: {
    item: { type: Object, default: () => {} }
  },

  data: function () {
    return {
      WalletRunningCountTypeMapper,
      arrowImg
    }
  },
  computed: {
    showArrow () {
      return !!(this.item.orderID || this.item.reportID)
    }
  },
  created: function () {},
  mounted: function () {},
  watch: {},
  methods: {
    // 跳转详情
    recordHandler () {
      try {
        // url 跳转
        const linkDetailFoo = WalletRunningCountTypeMapper[this.item.flowType].urlLink // 是个函数
        if (!!linkDetailFoo) {
          // 详情
          if (!this.item.orderID) {
            return this.$$toast('订单号丢失，请联系开发者（100900）')
          }
          const url = linkDetailFoo(this.item.orderID)
          window.location.href = url
        }

        // 微信小程序跳转
        const wxDetailFoo = WalletRunningCountTypeMapper[this.item.flowType].wxDetailLink // 是个函数
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!wxDetailFoo) {
          // 详情
          if (!this.item.orderID) {
            return this.$$toast('订单号丢失，请联系开发者（100902）')
          }
          if (window.isWXWebView) {
            const url = wxDetailFoo(this.item.orderID)
            wx.miniProgram.navigateTo({ url })
          } else {
            this.$$toast('暂未实现，请在包小鉴微信小程序中打开')
          }
        }
      } catch (e) {
        console.warn(e)
        this.$$toast('跳转失败，请联系开发者（1010）')
      }
    }
  },
  filters: {
    typeString (val) {
      return (WalletRunningCountTypeMapper[val] && WalletRunningCountTypeMapper[val].label) || '--'
    },
    preIcon (val) { // 加减号
      return WalletRunningCountTypeMapper[val] && WalletRunningCountTypeMapper[val].addOrsubt
    }
  }
}
</script>
